// extracted by mini-css-extract-plugin
module.exports = {"print":"print--85DqA","addButton":"addButton--2ZVGH","declaration":"declaration--3DQL5"};